import PropertySwitch from './components/PropertySwitch';
import BaseFeature from './BaseFeature';
import FeatureCard from './components/FeatureCard';
import { cn } from 'lib/utils';
import { DIM_TO_DARK } from '../../../../../../utils/constantFeatures';
import { getErrorIssues, getWarningIssues } from '../../../../../../utils/validationSummary';

export default class DimToDark extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.props.properties[DIM_TO_DARK.enable].value === "1" ? true : false
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {

        const v = value;
        this.props.handleChange(propertyName, v);

        if (this.getCorrectPropertyName(propertyName) === DIM_TO_DARK.enable) {
            this.setState({ isEnabled: v === "1" ? true : false });
        }
    }

    // Same error/warning signal as BaseFeature.getClassName, minus the legacy
    // .card-feature-component base class — that one is `width: fit-content` and would
    // beat the modern card's `w-full` (both single-class specificity, and
    // stylesheet.css loads after Tailwind).
    cardState(properties) {
        if (getErrorIssues(this.props.issues, properties).length > 0) return 'danger';
        if (getWarningIssues(this.props.issues, properties).length > 0) return 'warning';
        return '';
    }

    render() {

        const d2dEn = this.props.properties[DIM_TO_DARK.enable];

        return (
            // The card rendered full width in built output. Cause was not this page: the
            // minifier collapsed `.card-feature-component`'s `width: fit-content;
            // width: -moz-max-content` pair down to the invalid -moz value, so the card
            // fell back to `width: auto`. Fixed at source in stylesheet.css. A block-level
            // card like this one had nothing else holding its width in — pages that wrap
            // their card in `.flex-row` were never affected, because a flex item on the
            // main axis is content-sized regardless.
            //
            // The modern grid below sets the width explicitly, so this page no longer
            // depends on that CSS either way.
            //
            // PropertySwitch is deliberately still the legacy component, so the body
            // stays a plain block rather than bodyLayout="fields" — that grid expects
            // FieldRow children, and PropertySwitch renders its own Row/Col.
            <div className="mx-auto w-full max-w-[1800px] px-4 pb-4">
                <div className="grid grid-cols-1 gap-4 lg:grid-cols-3 xl:grid-cols-12">
                    <FeatureCard
                        variant="modern"
                        title={'Dim To Dark'}
                        className={cn('lg:col-span-1 xl:col-span-4', this.cardState([d2dEn]))}>
                        <PropertySwitch
                            property={d2dEn}
                            title={d2dEn.info.displayName.replace(/([A-Z])/g, ' $1')}
                            handleChange={this.handleChange} />
                    </FeatureCard>
                </div>
            </div>
        );
    }
}
